import type { RoundFeedCard, RoundFeedSide } from "../contracts/round-feed.js";
import { scoreNumber } from "../score-number.js";
export function posterScore(card: RoundFeedCard, side: RoundFeedSide) {
  const stroke = card.kind === "stroke",
    individual = side.participantIds.length === 1;
  return {
    value: String(
      stroke && individual
        ? side.incompleteStrokes
          ? "—"
          : scoreNumber(side.strokes)
        : (side.valueLabel ?? scoreNumber(side.value)),
    ),
    label: stroke
      ? !individual && card.basis === "net"
        ? "net strokes"
        : "strokes"
      : card.kind === "stableford"
        ? "points"
        : card.kind === "match"
          ? card.hasHoleBonuses
            ? "match points"
            : "holes won"
          : "",
    above:
      card.kind === "stableford" && side.strokes !== null
        ? `${scoreNumber(side.strokes)} ${side.incompleteStrokes ? "recorded strokes" : "strokes"}`
        : stroke && side.incompleteStrokes
          ? `${scoreNumber(side.strokes)} strokes recorded`
          : "",
    par:
      card.kind === "match" || side.versusPar === null
        ? null
        : side.versusPar === 0
          ? "E"
          : `${side.versusPar > 0 ? "+" : ""}${scoreNumber(side.versusPar)}`,
    below:
      stroke && individual && (card.basis === "net" || card.hasHoleBonuses)
        ? `${scoreNumber(side.value)} ${card.basis === "net" ? "net" : "competition"} · agreed result`
        : null,
  };
}
export function posterDate(card: RoundFeedCard): string {
  if (!card.date) return "Date not recorded";
  const date = new Date(card.date);
  return Number.isNaN(date.getTime())
    ? "Date not recorded"
    : date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
        ...(card.datePrecision === "date" ? { timeZone: "UTC" } : {}),
      });
}
